export function camelCaseToHumanReadable(str) {
  // Handle null, undefined, or non-string values
  if (!str || typeof str !== 'string') {
    return str || '';
  }
  
  const matches = str.match(/^[a-z]+|[A-Z][a-z]*/g);
  
  // Handle case where regex doesn't match anything
  if (!matches) {
    return str;
  }
  
  return matches
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1).toLowerCase();
    })
    .join(" ");
}
